module.exports = __webpack_public_path__ + "img/keypal-plus-light-m.5ece7ce8.png";